import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41438251
export const getLudoRankInfo = createAsyncThunk(
  'LudoRank/getLudoRankInfo',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/activity/ludorank_home', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const getLudoRankList = createAsyncThunk(
  'LudoRank/getLudoRankList',
  async (arg: {offset: number} = {offset: 0}, store: any) => {
    const resp = await http.post('/live/activity/ludorank_rank', {
      ...arg,
      ...store.getState().env.deviceinfo,
      limit: 10,
    })
    return {data: resp.data.data, offset: arg.offset}
  }
)

export const receiveVictoryPrize = createAsyncThunk(
  'LudoRank/receiveVictoryPrize',
  async (arg: {task_id: number}, store: any) => {
    const resp = await http.post('/live/activity/ludorank_victory_receive', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const receiveFriendPrize = createAsyncThunk(
  'LudoRank/receiveFriendPrize',
  async (arg: {task_id: number}, store: any) => {
    const resp = await http.post('/live/activity/ludorank_friend_receive', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const eraseRecord = createAsyncThunk(
  'LudoRank/eraseRecord',
  async (arg: {id: number}, store: any) => {
    const resp = await http.post('/live/activity/ludorank_erase', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const buyProps = createAsyncThunk(
  'LudoRank/buyProps',
  async (arg: {privilege_id: number}, store: any) => {
    const resp = await http.post('/live/activity/ludorank_buy', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

interface memberProps {
  rank: number
  score: number
  member_info: {
    avatar: string
    id: number
    zy_id: string
    name: string
  }
}
interface InitialStateType {
  eraseable: boolean
  erase_chips: number // 消除战绩需要的银币
  friend_cnt: number // 用户邀请的次数
  ludo_records: {
    id: number
    date_time: string
    bonus: number
    erase: 1 | 2 | 3 // 1: 不能消除 2: 未消除 3:以消除
    has_win: boolean // 是否获胜
  }[]
  exchange_infos: {
    privilege_id: number
    chips: number
    status: 1 | 2 // 1可买 2已买
    desc: string
    url: string // 图片url
    expire: number
  }[]
  victory_infos: {
    task_id: number // 数值对应连胜场次
    chips: number
    status: 1 | 2 | 3 // 1未解锁，2可领取，3已领取
    desc: string
    url: string
    expire: number
  }[]
  friend_infos: {
    task_id: number // 对应邀请次数
    chips: number
    desc: string
    status: 1 | 2 | 3 // 1未解锁， 2可领取， 3已领取
  }[]
  remain_t: number
  list: memberProps[]
  owner: memberProps
  infos: {
    privilege_id: number
    desc: string
    url: string
    expire: number
    coins: number
  }[]
  offset: number
  more: boolean
}
const initialState: InitialStateType = {
  eraseable: false,
  erase_chips: 0, // 消除战绩需要的银币
  ludo_records: [],
  exchange_infos: [],
  victory_infos: [],
  friend_infos: [
    {
      task_id: 0, // 对应邀请次数
      chips: 0,
      desc: 'xxxx',
      status: 1, // 1未解锁， 2可领取， 3已领取
    },
  ],
  friend_cnt: 0,
  remain_t: 0,
  list: [],
  owner: {} as any,
  infos: [],
  offset: 0,
  more: false,
} as any
export const LuckRankSlice = createSlice({
  name: 'LudoRank',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 基础接口必须保证返回
    // 失败就toast错误信息
    builder.addCase(getLudoRankInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getLudoRankList.fulfilled, (state, action) => {
      const {data, offset} = action.payload
      if (offset > 0) {
        Object.assign(state, {...data, list: [...state.list, ...data.list]})
      } else {
        Object.assign(state, data)
      }
    })
  },
})
export default LuckRankSlice.reducer
